import {
    WITHDRAW_LIST_METHOD,
    WITHDRAW_DETAIL_FORM,
    WITHDRAW_POST_FORM
} from "../../store/actions.type";
import {
    COMMON_SET_SNACK
} from "../../store/mutations.type";
import {WithdrawService} from "~/common/service.api";
import {getErrorMsg} from "~/common/helper.string";

const state = {
    accounts : {}
};

// getters
const getters = {
    accounts: state => state.reports
};

// actions
const actions = {
    [WITHDRAW_LIST_METHOD]({commit}) {
        return new Promise((resolve) => {
            WithdrawService.get('customer/withdrawal-money')
            .then(res => {
                if( res.data.success) {
                    resolve(res.data.data);
                }else{
                    commit(COMMON_SET_SNACK, {
                        message: res.data.message,
                        type: "error"
                    });
                    resolve(false);
                }
            })
            .catch(err => {
                commit(COMMON_SET_SNACK, {
                    message: getErrorMsg(err),
                    type: "error"
                });
                resolve(false);
            });
        });
    },
    [WITHDRAW_DETAIL_FORM]({commit}, param) {
        return new Promise((resolve) => {
            WithdrawService.query_params_string('customer/form-convert-detailV2', param)
            .then(res => {
                if( res.data.success) {
                    resolve(res.data.data);
                }else{
                    commit(COMMON_SET_SNACK, {
                        message: res.data.message,
                        type: "error"
                    });
                    resolve(false);
                }
            })
            .catch(err => {
                commit(COMMON_SET_SNACK, {
                    message: err.response.data.message,
                    type: "error"
                });
                resolve(false);
            });
        });
    },
    [WITHDRAW_POST_FORM]({commit}, params) {
        return new Promise((resolve) => {
            WithdrawService.post('customer/process-withdrawal-money', params)
            .then(res => {
                if (res.data.success) {
                    commit(COMMON_SET_SNACK, {
                        message: res.data.message,
                        type: "success"
                    });
                    resolve(res.data.data);
                } else {
                    commit(COMMON_SET_SNACK, {
                        message: res.data.message,
                        type: "error"
                    });
                    resolve(false);
                }
            })
            .catch(err => {
                commit(COMMON_SET_SNACK, {
                    message: err.response.data.message,
                    type: "error"
                });
                resolve(false);
            });
        });
    },
};

// mutations
const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
};
